
export const UnitOfMeasureConstant = {
    uom: 'api/UnitOfMeasure',   
    uomRoute: 'UOM',
    manageUOMRoute: 'manageUOM',
    bulkInsertMessage:'UOM codes are successfully importd',
    searchFieldName: 'name',
    code: 'code',
};